import {TextInput} from "component/input/TextInput";
import {useContext} from "react";
import {Context} from "./Context";
import {AboutTest} from "../../../../Test/component/AboutTest";

export default function SubmitMetaData({testId}) {

    const {metaData, setMetaData} = useContext(Context)

    const onChange = (value, toChange) => {
        setMetaData(prev => ({
            ...prev,
            [toChange]: value
        }))
    }

    return (<>
        <h2>일반 시험 출제하기</h2>
        <p style={{marginTop: "30px"}}>시험 정보</p>
        <AboutTest testId={testId}/>
        <table>
            <thead>
            <tr>
                <th>시험 개요</th>
                <th>출제자 메모</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td><TextInput value={metaData} toChange="testOverview" onChange={onChange}/></td>
                <td><TextInput value={metaData} toChange="submitterMemo" onChange={onChange}/></td>
            </tr>
            </tbody>
        </table>
    </>)
}
